<template lang="pug">
  v-flex
    v-layout
      v-text-field(v-model='search' prepend-icon='fa-search' label='Buscar' single-line hide-details)
      dataPickerCombobox(type='Sales')
    v-card
      v-card-title Ventas
        v-spacer
        formulario_maestro( modelo='Sales' )
      v-data-table.elevation-1( :headers="headers" :items="record" :search='search' :loading='Sales.loading' :footer-props="footerProps")
        template( v-slot:item.tipo_de_comprobante='{item}')
          span {{ item.tipo_de_comprobante | obtener_nombre_documento }} 
        template( v-slot:item.estado_del_documento="{item}")
          v-chip(small :color='obtener_color_de_estado(item.estado_del_documento)') {{ item.estado_del_documento | toUppercase}} 
        template( v-slot:item.action="{item}" )
          Botones(:estado_del_documento = 'item.estado_del_documento' :id = 'item.key' :message = 'item.message'  :link = 'item.link')           
    printerButtons(:dataToPrint = 'record')
 
  
        
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import { getPeriod } from '@/Helper'
import {fb} from '@/FirebaseConfig'
export default {
  data: ()=>({
    registerDialog: false,
    search: '',
    headers: [
      { text: 'Nº',                value: 'tipo_de_comprobante' },       
      { text: 'Serie',             value: 'serie' },   
      { text: 'Número',            value: 'numero' },
      { text: 'Cliente',           value: 'cliente_denominacion' },
      { text: 'total',             value: 'total' },
      { text: 'Almacén de origen', value: 'almacen_de_origen' },
      { text: 'Fecha de emision',  value: 'fecha_de_emision' },
      { text: 'Estado',  value: 'estado_del_documento' },
      { text: '',                  value: 'action', sortable: false },
    ],
    footerProps: {
      'items-per-page-options':   [15, 30, 50]
    }
  }),

  computed:{
    ...mapGetters({
      record: 'Sales/record',
    }),
    ...mapState({
      Sales: state => state.Sales
    })
  },  
  components:{
    formulario_maestro: ()=>import('@/components/formulario_maestro'),
    dataPickerCombobox: ()=>import('../../inventory/components/dataPickerCombobox'),
    printerButtons: ()=>import('../../inventory/components/printerButtons'),
    Botones: ()=>import('../components/Botones')
  },
  filters: {
    obtener_nombre_documento: (value) => {
      switch(value){
        case 1:
          return 'Factura'
          break
        case 2:
          return 'Boleta'
          break
        case 3: 
          return 'Nota de débito'
          break
        case 4: 
          return 'Nota de crédito'
          break
      }
    }
  }
}
</script>